<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose">

        <el-form
            ref="formData"
            :model="formData"
            label-width="150px"
        >
            <el-form-item label="快船到货天数：" prop="fast">
                <el-input-number
                    v-model="formData.out_of_stock_analysis_for_fast"
                    style="width: 300px;"
                    :min="0"
                    size="mini"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="中船到货天数：" prop="medium">
                <el-input-number
                    v-model="formData.out_of_stock_analysis_for_medium"
                    style="width: 300px;"
                    :min="0"
                    size="mini"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="慢船到货天数：" prop="slow">
                <el-input-number
                    v-model="formData.out_of_stock_analysis_for_slow"
                    style="width: 300px;"
                    :min="0"
                    size="mini"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="库存存储天数：" prop="dayNum">
                <el-input-number
                    v-model="formData.out_of_stock_analysis_for_max_inventory_day"
                    style="width: 300px;"
                    :min="0"
                    size="mini"
                >
                </el-input-number>
            </el-form-item>

        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
            >取 消
            </el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
            >确定
            </el-button
            >
        </el-row>

    </el-dialog>
</template>
<script>
    import * as api from "@/api/advAnalys/advAnalys";

    export default {
        data() {
            return {
                loading: false,
                fileList: [],
                obj: {},
                disabled: false,
                filesize: 0,
                value: '',
                file_data: null,
                formData: {}
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            us_arr: {
                type: Array,
                default: () => []
            },
            resData: {
                type: Object,
                default: () => {
                }
            }
        },
        mounted() {
            this.formData = this.resData
        },
        methods: {
            // 保存信息
            submitForm(formData) {
                this.$refs[formData].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.out_of_stock_analysis_set_config(this.formData)
                            .then(res => {
                                if (res.code === 0) {
                                    // 提交成功, 关闭窗口, 刷新列表
                                    this.$message({
                                        message: "设置成功",
                                        type: "success"
                                    });
                                    this.handleClose(false);
                                } else {
                                    this.loading = false;
                                    this.$message({
                                        type: "error",
                                        message: res.message
                                    });
                                }
                            })
                            .catch(() => {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message:
                                        "网络出现错误，请刷新页面后，再次尝试！"
                                });
                            });
                    } else {
                        this.$message({
                            type: "error",
                            message: "请填写相应内容！"
                        });
                    }
                });
            },
            // 关闭弹窗
            handleClose(isshow) {
                this.$refs["formData"].resetFields();
                this.loading = false;
                this.$emit("close-callback", isshow);
            }
        }
    }
</script>
